export default __webpack_public_path__ + "static/media/2OMB.312af30f.png";